import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case05.introduction-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  description: {
    id: `${PREFIX}.description`,
  },
});
